export const reelInsightModes = [
  {
    key: 'extract_value',
    label: 'Extract Value',
    description: 'Break down what worked, visual beats, CTA, caption angles, and reusable lessons.'
  },
  {
    key: 'viral_assessment',
    label: 'Viral Assessment',
    description: 'Harshly score hook, first frame, open loop, CTA, pacing, retention, payoff, and shareability.'
  }
];

export const REEL_MAX_UPLOAD_BYTES = 100 * 1024 * 1024;
export const REEL_ALLOWED_TYPES = ['video/mp4', 'video/quicktime', 'video/webm'];
export const REEL_ACCEPT = '.mp4,.mov,.webm,video/mp4,video/quicktime,video/webm';

const getErrorMessage = async (response) => {
  const text = await response.text();
  if (!text) return 'Request failed.';

  try {
    const body = JSON.parse(text);
    return body?.error || body?.message || text;
  } catch {
    return text;
  }
};

const apiRequest = async (path, { accessToken, method = 'GET', body } = {}) => {
  const response = await fetch(path, {
    method,
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...(body ? { 'Content-Type': 'application/json' } : {})
    },
    body: body ? JSON.stringify(body) : undefined
  });

  if (!response.ok) {
    throw new Error(await getErrorMessage(response));
  }

  if (response.status === 204) return null;
  return response.json();
};

export const getReelInsightsConfig = ({ accessToken, dashboardId = 'vasia' }) => {
  const params = new URLSearchParams({ dashboardId });
  return apiRequest(`/api/reel-insights/config?${params}`, { accessToken });
};

export const listReelInsights = ({ accessToken, dashboardId = 'vasia' }) => {
  const params = new URLSearchParams({ dashboardId });
  return apiRequest(`/api/reel-insights/list?${params}`, { accessToken });
};

export const createReelUploadUrl = ({ accessToken, dashboardId = 'vasia', title, reelUrl, mode, file }) => {
  return apiRequest('/api/reel-insights/upload-url', {
    accessToken,
    method: 'POST',
    body: {
      dashboardId,
      title,
      reelUrl: reelUrl || null,
      mode,
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size
    }
  });
};

export const uploadReelToSignedUrl = async ({ uploadUrl, file }) => {
  const response = await fetch(uploadUrl, {
    method: 'POST',
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
      'x-upsert': 'false'
    },
    body: file
  });

  if (!response.ok) {
    throw new Error(await getErrorMessage(response));
  }

  return response.text().catch(() => '');
};

export const analyzeReel = ({ accessToken, analysisId }) => {
  return apiRequest('/api/reel-insights/analyze', {
    accessToken,
    method: 'POST',
    body: { analysisId }
  });
};

export const deleteReelInsight = ({ accessToken, analysisId }) => {
  return apiRequest(`/api/reel-insights/${encodeURIComponent(analysisId)}`, {
    accessToken,
    method: 'DELETE'
  });
};
